import { useState } from 'react';

import { PropertyCard } from '@zillow/constellation-10';

type Props = {
  src: string;
  alt: string;
};

// PropertyCard.Photo renders its fallback only when src is empty; it has no error handling, so a
// photoKey the CDN can't serve would otherwise show a broken image.
export const PropertyPhoto = ({ src, alt }: Props) => {
  const [renderedSrc, setRenderedSrc] = useState(src);
  const [hasFailed, setHasFailed] = useState(false);

  // Adjusted during render rather than in an effect, which would paint a frame of fallback first.
  if (renderedSrc !== src) {
    setRenderedSrc(src);
    setHasFailed(false);
  }

  if (!src || hasFailed) {
    return (
      <PropertyCard.Photo
        alt={alt}
        fallbackImg={<PropertyCard.PhotoFallback />}
        css={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    );
  }

  return (
    <PropertyCard.Photo src={src} alt={alt} css={{ width: '100%', height: '100%', objectFit: 'cover' }} asChild={true}>
      {/* oxlint-disable-next-line next/no-img-element -- external/remote photo CDN not allowlisted for next/image, no fixed dimensions, composed via asChild into PropertyCard.Photo */}
      <img onError={() => setHasFailed(true)} />
    </PropertyCard.Photo>
  );
};
